import axios from '@/plugins/axios';
import enumerateArray from '@/helpers/enumerateArray';

const initialState = {
  list: [],
  currentPage: 1,
  lastPage: 1,
  perPage: 100,
  statuses: [],
};

const actions = {
  async fetchList({ commit }, params) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('fines', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params,
      });

      const fines = {
        ...data.data.fines,
        data: enumerateArray(
          data.data.fines.data,
          data.data.fines.current_page,
          data.data.fines.per_page,
        ),
      };

      commit('setListData', fines);

      return data;
    } catch (error) {
      return error;
    }
  },

  async fetchStatuses({ commit }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('fines/statuses', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const statuses = data.data.map((item, idx) => ({ name: item, id: idx }));

      commit('setStatuses', statuses);

      return data;
    } catch (error) {
      return error;
    }
  },

  async addNew(_, params) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.post('fines', params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch {
      return { error: true };
    }
  },

  async updateItem(_, { id, params }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.put(`fines/${id}`, params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch {
      return { error: true };
    }
  },

  async fetchDriverByDate(_, { date, number }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('fines/autocomplete', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params: { date, number },
      });

      return { driver: data.data };
    } catch (error) {
      return error;
    }
  },
};

const mutations = {
  setList(state, payload) {
    state.list = payload;
  },

  setListData(state, payload) {
    state.list = payload.data;
    state.currentPage = payload.current_page;
    state.lastPage = payload.last_page;
    state.perPage = payload.per_page;
  },

  setStatuses(state, payload) {
    state.statuses = payload;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
